import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import React, { useState } from 'react';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Toolbar from '@material-ui/core/Toolbar';
/**
 * @param {import('./types').SideBarHeaderProps} props
 */

var SideBarHeader = function SideBarHeader(props) {
  var title = props.title,
      primary = props.primary,
      primaryMuted = props.primaryMuted,
      editable = props.editable,
      onDescriptionSubmit = props.onDescriptionSubmit;

  var _useState = useState(!editable),
      _useState2 = _slicedToArray(_useState, 2),
      editLocked = _useState2[0],
      setEditLocked = _useState2[1];

  var _useState3 = useState({
    editEnabled: false,
    description: primary
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      _useState4$ = _useState4[0],
      editEnabled = _useState4$.editEnabled,
      description = _useState4$.description,
      setDescription = _useState4[1];

  var handleSubmit = function handleSubmit() {
    toggleEditEnabled(false);

    if (primary !== description) {
      if (onDescriptionSubmit) {
        var promise = onDescriptionSubmit(description.trim());

        if (promise.then) {
          setEditLocked(true);
          promise.catch(function () {
            setDescription({
              editEnabled: false,
              description: primary
            });
          }).finally(function () {
            return setEditLocked(false);
          });
        }
      }
    }
  };

  var handleDescriptionFocus = function handleDescriptionFocus(_ref) {
    var target = _ref.target;
    return target.select();
  };

  var handleKeyDown = function handleKeyDown(e) {
    if (e.key === 'Enter' || e.key === 'Escape') handleSubmit();
  };

  var handleDescriptionChange = function handleDescriptionChange(_ref2) {
    var target = _ref2.target;
    return setDescription({
      editEnabled: editEnabled,
      description: target.value
    });
  };

  var toggleEditEnabled = function toggleEditEnabled(editEnabled) {
    return setDescription({
      editEnabled: editEnabled,
      description: description.trim()
    });
  };

  return React.createElement(React.Fragment, null, React.createElement("div", {
    style: {
      paddingLeft: 8 * 2,
      paddingRight: 8 * 2
    }
  }, React.createElement(Toolbar, {
    style: {
      minHeight: 50
    },
    disableGutters: true
  }, React.createElement(Typography, {
    variant: "h6"
  }, title)), !editEnabled || editLocked ? React.createElement(Typography, {
    component: "div",
    style: {
      opacity: primaryMuted ? 0.7 : 1,
      marginBottom: 8 * 2,
      wordBreak: 'break-word'
    },
    onClick: function onClick() {
      return toggleEditEnabled(true);
    }
  }, description || React.createElement("i", null, "No description")) : React.createElement(TextField, {
    autoFocus: true,
    multiline: true,
    fullWidth: true,
    value: description,
    variant: "filled",
    onFocus: handleDescriptionFocus,
    onKeyDown: handleKeyDown,
    onChange: handleDescriptionChange,
    onBlur: handleSubmit,
    placeholder: "No description",
    InputProps: {
      disableUnderline: true,
      inputProps: {
        maxLength: 128
      },
      style: {
        padding: 0,
        lineHeight: 1.5
      }
    },
    style: {
      marginBottom: 7 * 2
    }
  })));
};

SideBarHeader.defaultProps = {
  title: '',
  primary: '',
  primaryMuted: false,
  editable: false
};
export default SideBarHeader;